import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogButton} from '@mintdata-wsp/wsp/ui/components/forms/DialogButton';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonSize, ButtonStyle} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('@mintdata-wsp/wsp/ui/dialogs/publish/PublishConfirmUrlChangeDialog.less');
const cx = classnames.bind(styles);

export interface IPublishConfirmUrlChangeDialogProps
{
    oldValue:string;
    newValue:string;
    onConfirm:() => void;
}

@observer
export class PublishConfirmUrlChangeDialog extends React.Component<IPublishConfirmUrlChangeDialogProps, any>
{
    @bind
    private _closeDialog()
    {
        controllers.ui.dialogs.hideDialog(Dialogs.PublishConfirmUrlChange);
    }

    @bind
    private _onCancelClicked():void
    {
        this._closeDialog();
    }

    @bind
    private _onConfirmClicked():void
    {
        const {onConfirm} = this.props;

        onConfirm && onConfirm();
        this._closeDialog();
    }

    @bind
    private _urlFormatter(value:string):string
    {
        return controllers.ui.publish.computeFullUrl(value);
    }

    public render():JSX.Element
    {
        const {oldValue, newValue} = this.props;

        const {isBeta, designRef} = rootState.ui.publish.request;

        const versionTitle:string = isBeta ? 'staging' : 'production';

        return (
            <Dialog
                className={styles.dialog}
                title={'Confirm URL change'}
                onClose={this._onCancelClicked}
            >
                <Column className={styles.content}>

                    <Row className={styles.currentInfo}>
                        <MDIcon
                            name={MDIcons.common.InfoCircle}
                            className={styles.iconInfo}
                        />
                        <div className={styles.infoText}>
                            The {versionTitle} version
                            of the <b>{designRef.designName}</b> design
                            is currently published here: <br />
                            <a
                                className={styles.linkColor}
                                target="_blank"
                                href={this._urlFormatter(oldValue)}
                            >
                                {this._urlFormatter(oldValue)}
                            </a>
                            {/*<span className={styles.linkColor}>*/}
                            {/*    {this._urlFormatter(oldValue)}*/}
                            {/*</span>*/}
                        </div>
                    </Row>

                    <Column className={styles.links}>
                        <div>
                            <b>You are about to:</b>
                        </div>
                        <Row className={styles.linkLine}>
                            <div className={styles.number}>1</div>
                            <div>
                                Unpublish the <b>old {versionTitle}</b> application from: <br />
                                {/*<span className={styles.linkColor}>*/}
                                {/*    {this._urlFormatter(oldValue)}*/}
                                {/*</span>*/}
                                <a
                                    className={styles.linkColor}
                                    target="_blank"
                                    href={this._urlFormatter(oldValue)}
                                >
                                    {this._urlFormatter(oldValue)}
                                </a>
                            </div>
                        </Row>
                        <Row className={styles.linkLine}>
                            <div className={styles.number}>2</div>
                            <div>
                                Publish the <b>new {versionTitle}</b> application to: <br />
                                <span className={styles.linkColor}>
                                    {this._urlFormatter(newValue)}
                                </span>
                            </div>
                        </Row>
                    </Column>

                    <Row>
                        <MDIcon
                            name={MDIcons.common.ReportProblem}
                            className={styles.iconReport}
                        />
                        <span>
                            All end-user bookmarks to the old URL will no longer work.
                        </span>
                    </Row>

                    <div className={styles.question}>
                        Are you sure you want to <b>change the URL</b> of the published application?
                    </div>

                </Column>

                <Row className={styles.actionRow}>
                    <DialogButton
                        caption={'Cancel'}
                        onClick={this._onCancelClicked}
                        style={ButtonStyle.SimpleSecondary}
                        size={ButtonSize.Large}
                        className={styles.cancelBtn}
                    />
                    <DialogButton
                        caption={'Confirm'}
                        onClick={this._onConfirmClicked}
                        style={ButtonStyle.Raised}
                        size={ButtonSize.Large}
                        // icon={MDIcons.common.KeyboardBackspace}
                        // iconClassName={styles.iconArrow}
                    />
                </Row>

            </Dialog>
        );
    }
}
